import { Controller } from 'stimulus';

export default class extends Controller {
  unlock() {
    this.#setDisabled(false);
  }

  lock() {
    this.#setDisabled(true);
  }

  #setDisabled(disabled) {
    this.element.form.querySelectorAll('fieldset').forEach((fieldset) => {
      fieldset.disabled = disabled;
    });
    this.#tippy?.hide();
  }

  get #tippy() {
    return this.element.closest('[data-tippy-root], .tooltip')?._tippy;
  }
}
